//import { combineReducers } from 'redux-immutable';
import { mergeReducers } from 'redux-merge-immutable-reducers';
import { combineActions, handleActions } from 'redux-actions';
import { Map } from 'immutable';
import coreHotels from '@synergycms_core/store/hotels/hotels';
import actions from '../actions';

//REDUCERS
const hotelsActions = actions.hotels;
const hotels = handleActions(
  {
    [combineActions(hotelsActions.getAsync.toString(), hotelsActions.get.toString())]: (hotels, { payload }) => {
      payload.forEach((hotel, hotelId) => {
        hotels = hotels.set(hotelId, hotels.get(hotelId, Map()).merge(hotel));
      });

      return hotels;
    },
    [hotelsActions.setLastQueryParams.toString()]: (hotels, { payload }) => {
      payload.forEach((hotel) => {
        const params = hotels.getIn([hotel.get('hotelId'), 'params'], Map());
        hotels = hotels.setIn([hotel.get('hotelId'), 'params'], params.merge(hotel));
      });
      return hotels;
    }
  },
  Map()
);

//REDUCERS
export default mergeReducers(hotels, coreHotels);
